import React from 'react';
import { Typography } from '@mui/material';
import { css } from '@emotion/react';
import { CustomLink } from '@/components/CustomLink';
import { WindowDimension } from '@/utils/WindowDemension';

const EMAIL_ADDRESS = 'contact@legalengine.co.kr';

// e.g., © 2019, Jane Doe. All rights reserved.

const url = 'https://legalengine.co.kr/';
const name = 'Carillon Inc';

export const Copyright = () => {
  return (
    <Typography textAlign='start' variant='body2' color='text.secondary' align='center'>
      {`© ${new Date().getFullYear()}, `}
      <CustomLink
        color='inherit'
        href={url}
        css={css`
          text-decoration: none;
        `}
      >
        {name}
      </CustomLink>
      {'. All rights reserved.'}
    </Typography>
  );
};

export const Footer = () => {
  const { width } = WindowDimension();
  return (
    <>
      {width > 993 ? (
        <footer
          css={css`
            background-color: #f8f9fa;
            overflow: hidden;
            padding: 2rem 0;
            line-height: 165%;
          `}
        >
          <div
            css={css`
              display: flex;
              flex-direction: row;
              justify-content: center;
              color: #424242;
              font-size: 14px;
              font-weight: 400;
            `}
          >
            <div>
              <div>{`주식회사 까리용 © 2019 Carillon Inc., All rights reserved.`}</div>
              <div>{`대표: 오경원 | 주소: 서울시 강남구 테헤란로 503, 1207호`}</div>
              <div>{`사업자 등록번호: 257-81-01787`}</div>
              <div>{`통신판매업 신고번호: 제 2021-서울강남-03354호`}</div>
              <a
                href={`mailto:${EMAIL_ADDRESS}`}
                css={css`
                  font-size: 0.8rem;
                  color: inherit;
                  text-decoration: none;
                `}
              >
                {`이메일: ${EMAIL_ADDRESS}`}
              </a>
            </div>
            <div
              css={css`
                border-right: 0.5px solid #424242;
                margin: 0 2rem;
              `}
            />
            <div
              css={css`
                display: flex;
                flex-direction: column;
                a {
                  text-decoration: none;
                  color: #424242;
                  &:hover {
                    font-weight: 500;
                  }
                }
              `}
            >
              <a
                href='https://legalengine.co.kr/search?q=무죄&p=1&level1_case=전문%20판례&level0=판례&bub_nm_category=서울고등법원'
                target='_blank'
                rel='noreferrer'
              >{`판례검색`}</a>
              <a
                href='https://legalengine.co.kr/termsofservice'
                target='_blank'
                rel='noreferrer'
              >{`이용약관`}</a>
              <a
                href='https://legalengine.co.kr/privacypolicy'
                target='_blank'
                rel='noreferrer'
              >{`개인정보 처리방침`}</a>
              <a
                href='https://legalengine.co.kr/update'
                target='_blank'
                rel='noreferrer'
              >{`업데이트`}</a>
              <a
                href='https://legalengine.co.kr/aboutus'
                target='_blank'
                rel='noreferrer'
              >{`회사소개`}</a>
            </div>
          </div>
        </footer>
      ) : (
        <footer
          css={css`
            background-color: #f8f9fa;
            overflow: hidden;
            padding: 2rem 0;
            line-height: 165%;
          `}
        >
          <div
            css={css`
              display: flex;
              flex-direction: column;
              justify-content: center;
              color: #424242;
              font-size: 14px;
              font-weight: 400;
            `}
          >
            <div
              css={css`
                display: flex;
                flex-flow: row wrap;
                align-items: center;
                justify-content: space-between;
                margin: 0 auto;
                width: 90%;
                a {
                  margin: 0 auto;
                  text-align: center;
                  flex: 0 0 50%;
                  width: 50%;
                  text-decoration: none;
                  color: #424242;
                  &:hover {
                    font-weight: 500;
                  }
                }
              `}
            >
              <a
                href='https://legalengine.co.kr/termsofservice'
                target='_blank'
                rel='noreferrer'
              >{`이용약관`}</a>
              <a
                href='https://legalengine.co.kr/privacypolicy'
                target='_blank'
                rel='noreferrer'
              >{`개인정보 처리방침`}</a>
              <a
                href='https://legalengine.co.kr/update'
                target='_blank'
                rel='noreferrer'
              >{`업데이트`}</a>
              <a
                href='https://legalengine.co.kr/aboutus'
                target='_blank'
                rel='noreferrer'
              >{`회사소개`}</a>
              <a
                href='https://legalengine.co.kr/search?q=무죄&p=1&level1_case=전문%20판례&level0=판례&bub_nm_category=서울고등법원'
                target='_blank'
                rel='noreferrer'
                css={css`
                  margin: 0 !important;
                `}
              >{`판례검색`}</a>
            </div>
            <div
              css={css`
                text-align: center;
                padding-top: 1.7rem;
              `}
            >
              <div>{`주식회사 까리용 | 대표: 오경원`}</div>
              <div>{`주소: 서울시 강남구 테헤란로 503, 1207호`}</div>
              <div>{`사업자 등록번호: 257-81-01787`}</div>
              <div>{`통신판매업 신고번호: 제 2021-서울강남-03354호`}</div>

              <a
                href={`mailto:${EMAIL_ADDRESS}`}
                css={css`
                  font-size: 0.8rem;
                  color: inherit;
                  text-decoration: none;
                `}
              >
                {`이메일: ${EMAIL_ADDRESS}`}
              </a>
              <div
                css={css`
                  padding-top: 1.7rem;
                `}
              >{`© 2019 Carillon Inc., All rights reserved.`}</div>
            </div>
          </div>
        </footer>
      )}
    </>
  );
};
